import { combineReducers } from "@reduxjs/toolkit";
import { connectRouter } from "connected-react-router";

import { layoutSlice  ,clientSlice , dominantColorSlice } from "./features";


const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        clientSlice,
        layoutSlice,
        dominantColorSlice,
    });

export default createRootReducer;
